import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Home = () => {
const [currentSlide, setCurrentSlide] = useState(0);
const [isVisible, setIsVisible] = useState({});
 const navigate = useNavigate();

const slides = [
{
image: "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=1200&h=600&fit=crop",
title: "Welcome to Nakshatra Infra Projects",
subtitle: "HMDA & RERA Approved Properties",
description: "Invest in your future with our premium open plots"
},
{
image: "https://images.unsplash.com/photo-1580587771525-78b9dba3b914?w=1200&h=600&fit=crop",
title: "Luxury Residential Ventures",
subtitle: "Your Dream Home Awaits",
description: "Modern living spaces designed for comfort"
},
{
image: "https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?w=1200&h=600&fit=crop",
title: "Commercial Ventures",
subtitle: "Invest in Profitable Properties",
description: "Strategic locations for maximum returns"
}
];

useEffect(() => {
const interval = setInterval(() => {
setCurrentSlide((prev) => (prev + 1) % slides.length);
}, 5000);
return () => clearInterval(interval);
}, []);

useEffect(() => {
const observer = new IntersectionObserver(
(entries) => {
entries.forEach((entry) => {
if (entry.isIntersecting) {
setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
}
});
},
{ threshold: 0.1 }
);

document.querySelectorAll('[id^="section-"]').forEach((el) => {
observer.observe(el);
});

return () => observer.disconnect();
}, []);

const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % slides.length);
const prevSlide = () => setCurrentSlide((prev) => (prev - 1 + slides.length) % slides.length);

const features = [
{
icon: "🏆",
title: "HMDA Approved",
description: "All projects are legally compliant with HMDA and RERA approvals for your peace of mind"
},
{
icon: "🏗️",
title: "Quality Construction",
description: "Premium materials and expert craftsmanship in every project we undertake"
},
{
icon: "💰",
title: "Flexible Payment",
description: "Easy EMI options and bank loan assistance to make your dream affordable"
},
{
icon: "📍",
title: "Prime Locations",
description: "Strategic locations near IT hubs, schools, hospitals, and metro stations"
}
];

const projects = [
{
title: "Green Valley Plots",
location: "Shamshabad, Hyderabad",
size: "150-300 sq yards",
price: "₹35 Lakhs onwards",
status: "80% Sold Out",
image: "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=400&h=300&fit=crop"
},
{
title: "Skyline Residency",
location: "Kompally, Hyderabad",
size: "2BHK & 3BHK",
price: "₹55 Lakhs onwards",
status: "Booking Open",
image: "https://images.unsplash.com/photo-1545324418-cc1a3fa10c00?w=400&h=300&fit=crop"
},
{
title: "Tech Park Commercial",
location: "Gachibowli, Hyderabad",
size: "1000-5000 sq ft",
price: "₹1.2 Cr onwards",
status: "Pre-Launch",
image: "https://images.unsplash.com/photo-1497366216548-37526070297c?w=400&h=300&fit=crop"
}
];

const stats = [
{ number: "500+", label: "Happy Families" },
{ number: "10+", label: "Projects Completed" },
{ number: "6+", label: "Years Experience" },
{ number: "200+", label: "Acres Developed" }
];

const testimonials = [
{
name: "Rajesh Kumar",
role: "Software Engineer",
image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=100&h=100&fit=crop",
text: "Excellent service and transparency. Got my dream plot in Shamshabad with complete documentation support. Highly recommended!"
},
{
name: "Priya Sharma",
role: "Business Owner",
image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=100&h=100&fit=crop",
text: "Professional team and great location. The bank loan process was smooth. Very happy with my investment."
},
{
name: "Vikram Reddy",
role: "Doctor",
image: "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?w=100&h=100&fit=crop",
text: "Trustworthy company with RERA approved projects. The property value has already appreciated. Great ROI!"
}
];

return (
<div style={{ fontFamily: 'Segoe UI, sans-serif' }}>

  {/* Hero Carousel */}
  <div style={{ position: 'relative', height: '600px', overflow: 'hidden' }}>
    {slides.map((slide, index) => (
    <div key={index} style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              opacity: currentSlide === index ? 1 : 0,
pointerEvents: currentSlide === index ? 'auto' : 'none',
              transition: 'opacity 1s ease-in-out',
              backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${slide.image})`,
              backgroundSize: 'cover',
              backgroundPosition: 'center',
            }}>
      <div style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              textAlign: 'center',
              color: 'white',
              width: '90%',
              maxWidth: '800px'
            }}>
        <h1 style={{
                fontSize: 'clamp(2rem, 5vw, 4rem)',
                fontWeight: '700',
                marginBottom: '1rem',
                textShadow: '2px 2px 4px rgba(0,0,0,0.5)'
              }}>
          {slide.title}
        </h1>
        <p style={{
                fontSize: 'clamp(1.2rem, 3vw, 1.8rem)',
                marginBottom: '0.5rem',
                textShadow: '1px 1px 2px rgba(0,0,0,0.5)'
              }}>
          {slide.subtitle}
        </p>
        <p style={{
                fontSize: 'clamp(1rem, 2vw, 1.3rem)',
                opacity: 0.9,
                marginBottom: '2rem'
              }}>
          {slide.description}
        </p>
        <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center', flexWrap: 'wrap' }}>
          <button
  onClick={() => navigate('/projects/CompletedProjects')}
  style={{
    padding: '1rem 2.5rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    background: '#FFBE1D',
    border: 'none',
    borderRadius: '50px',
    color: '#000',
    cursor: 'pointer',
    transition: 'all 0.3s ease',
    boxShadow: '0 5px 20px rgba(255,190,29,0.4)'
  }}
>
  Explore Projects
  
</button>
          <button
  onClick={() => navigate('/contact')}
  style={{
    padding: '1rem 2.5rem',
    fontSize: '1.1rem',
    fontWeight: '600',
    background: 'transparent',
    border: '2px solid white',
    borderRadius: '50px',
    color: 'white',
    cursor: 'pointer',
    transition: 'all 0.3s ease'
  }}
>
  Contact Us
</button>
        </div>
      </div>
    </div>
    ))}

    {/* Navigation Arrows */}
    <button onClick={prevSlide} style={{
          position: 'absolute',
          left: '20px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.3)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          fontSize: '1.5rem',
          color: 'white',
          cursor: 'pointer',
          backdropFilter: 'blur(5px)',
          transition: 'all 0.3s ease'
        }} onMouseOver={(e)=> e.target.style.background = 'rgba(255,255,255,0.5)'}
      onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}>
      ‹
    </button>
    <button onClick={nextSlide} style={{
          position: 'absolute',
          right: '20px',
          top: '50%',
          transform: 'translateY(-50%)',
          background: 'rgba(255,255,255,0.3)',
          border: 'none',
          borderRadius: '50%',
          width: '50px',
          height: '50px',
          fontSize: '1.5rem',
          color: 'white',
          cursor: 'pointer',
          backdropFilter: 'blur(5px)',
          transition: 'all 0.3s ease'
        }} onMouseOver={(e)=> e.target.style.background = 'rgba(255,255,255,0.5)'}
      onMouseOut={(e) => e.target.style.background = 'rgba(255,255,255,0.3)'}>
      ›
    </button>

    {/* Indicators */}
    <div style={{
          position: 'absolute',
          bottom: '30px',
          left: '50%',
          transform: 'translateX(-50%)',
          display: 'flex',
          gap: '10px'
        }}>
      {slides.map((_, index) => (
      <button key={index} onClick={()=> setCurrentSlide(index)}
        style={{
                width: currentSlide === index ? '40px' : '12px',
                height: '12px',
                borderRadius: '6px',
                background: currentSlide === index ? 'white' : 'rgba(255,255,255,0.5)',
                border: 'none',
                cursor: 'pointer',
                transition: 'all 0.3s ease'
              }}
        />
        ))}
    </div>
  </div>

  {/* Welcome Section */}
  <div id="section-welcome" style={{
        padding: '4rem 2rem',
        textAlign: 'center',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        opacity: isVisible['section-welcome'] ? 1 : 0,
        transform: isVisible['section-welcome'] ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: '700',
            color: '#1e3c72',
            marginBottom: '1.5rem'
          }}>
        Welcome to Nakshatra Infra Projects
      </h2>
      <div style={{
            width: '100px',
            height: '4px',
            background: 'linear-gradient(90deg, #667eea, #764ba2)',
            margin: '0 auto 2rem',
            borderRadius: '2px'
          }}></div>
      <p style={{
            fontSize: 'clamp(1.1rem, 2vw, 1.4rem)',
            color: '#555',
            lineHeight: '1.8',
            maxWidth: '900px',
            margin: '0 auto 2rem'
          }}>
        Your Trusted Real Estate Partner in Hyderabad - Specializing in HMDA & RERA Approved Projects
      </p>
      <p style={{
            fontSize: 'clamp(1rem, 1.5vw, 1.2rem)',
            color: '#666',
            lineHeight: '1.8',
            maxWidth: '1000px',
            margin: '0 auto'
          }}>
        Nakshatra Infra Projects is a premier real estate company in Hyderabad, committed to delivering exceptional open
        plots, residential ventures, and commercial properties. With over 15 years of experience, we ensure complete
        transparency, legal compliance, and customer satisfaction. Our mission is to help you build your dream home or
        make profitable investments with confidence and trust.
      </p>
    </div>
  </div>

  {/* Stats Section */}
  <div style={{
        padding: '3rem 2rem',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white'
      }}>
    <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'grid',
          gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
          gap: '2rem'
        }}>
      {stats.map((stat, index) => (
      <div key={index} className="stat-card" style={{
              textAlign: 'center',
              padding: '1.5rem',
              transition: 'transform 0.3s ease'
            }}>
        <div style={{
                fontSize: 'clamp(2.5rem, 5vw, 4rem)',
                fontWeight: '700',
                marginBottom: '0.5rem'
              }}>
          {stat.number}
        </div>
        <div style={{
                fontSize: 'clamp(1rem, 2vw, 1.2rem)',
                opacity: 0.9
              }}>
          {stat.label}
        </div>
      </div>
      ))}
    </div>
  </div>

  {/* Features Section */}
  <div id="section-features" style={{
        padding: '4rem 2rem',
        background: 'white',
        opacity: isVisible['section-features'] ? 1 : 0,
        transform: isVisible['section-features'] ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            fontWeight: '700',
            color: '#1e3c72',
            textAlign: 'center',
            marginBottom: '1rem'
          }}>
        Why Choose Nakshatra Infra?
      </h2>
      <p style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '1.1rem',
            marginBottom: '3rem'
          }}>
        Experience excellence in real estate with our comprehensive services
      </p>
      <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 1fr))',
            gap: '2rem'
          }}>
        {features.map((feature, index) => (
        <div key={index} className="feature-card" style={{
                background: 'white',
                borderRadius: '15px',
                padding: '2rem',
                textAlign: 'center',
                boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                transition: 'all 0.3s ease'
              }}>
          <div style={{
                  fontSize: '3rem',
                  marginBottom: '1rem'
                }}>
            {feature.icon}
          </div>
          <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  color: '#1e3c72',
                  marginBottom: '1rem'
                }}>
            {feature.title}
          </h3>
          <p style={{
                  color: '#666',
                  lineHeight: '1.6',
                  fontSize: '1rem'
                }}>
            {feature.description}
          </p>
        </div>
        ))}
      </div>
    </div>
  </div>

  {/* Services Section */}
  <div id="section-services" style={{
        padding: '4rem 2rem',
        background: 'white',
        opacity: isVisible['section-services'] ? 1 : 0,
        transform: isVisible['section-services'] ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            fontWeight: '700',
            color: '#1e3c72',
            textAlign: 'center',
            marginBottom: '1rem'
          }}>
        Our Comprehensive Services
      </h2>
      <p style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '1.1rem',
            marginBottom: '3rem'
          }}>
        End-to-end real estate solutions tailored to your needs
      </p>
      <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '2rem'
          }}>
        {[
        {
        title: "Plot Sales",
        desc: "Premium open plots in strategic locations with complete documentation and legal clearance",
        icon: "🏞️"
        },
        {
        title: "Venture Development",
        desc: "Turnkey residential and commercial project development from concept to completion",
        icon: "🏢"
        },
        {
        title: "Bank Loan Assistance",
        desc: "Seamless loan processing support with tie-ups from leading banks for easy financing",
        icon: "💳"
        },
        {
        title: "Property Investment",
        desc: "Expert guidance on profitable real estate investments with high ROI potential",
        icon: "📈"
        },
        {
        title: "Legal Services",
        desc: "Complete legal documentation, title verification, and registration support",
        icon: "⚖️"
        },
        {
        title: "Site Visits",
        desc: "Free site visits and personalized property tours with our expert team",
        icon: "🚗"
        }
        ].map((service, index) => (
        <div key={index} style={{
                background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
                borderRadius: '15px',
                padding: '2rem',
                color: 'white',
                transition: 'all 0.3s ease',
                cursor: 'pointer'
              }} onMouseOver={(e)=> e.currentTarget.style.transform = 'translateY(-5px)'}
          onMouseOut={(e) => e.currentTarget.style.transform = 'translateY(0)'}>
          <div style={{ fontSize: '3rem', marginBottom: '1rem' }}>{service.icon}</div>
          <h3 style={{
                  fontSize: '1.4rem',
                  fontWeight: '600',
                  marginBottom: '1rem'
                }}>
            {service.title}
          </h3>
          <p style={{
                  opacity: 0.9,
                  lineHeight: '1.6'
                }}>
            {service.desc}
          </p>
        </div>
        ))}
      </div>
    </div>
  </div>

  {/* Testimonials Section */}
  <div id="section-testimonials" style={{
        padding: '4rem 2rem',
        background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
        opacity: isVisible['section-testimonials'] ? 1 : 0,
        transform: isVisible['section-testimonials'] ? 'translateY(0)' : 'translateY(30px)',
        transition: 'all 0.8s ease'
      }}>
    <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
      <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.5rem)',
            fontWeight: '700',
            color: '#1e3c72',
            textAlign: 'center',
            marginBottom: '1rem'
          }}>
        What Our Clients Say
      </h2>
      <p style={{
            textAlign: 'center',
            color: '#666',
            fontSize: '1.1rem',
            marginBottom: '3rem'
          }}>
        Real stories from satisfied customers who trusted us
      </p>
      <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
            gap: '2rem'
          }}>
        {testimonials.map((testimonial, index) => (
        <div key={index} style={{
                background: 'white',
                borderRadius: '15px',
                padding: '2rem',
                boxShadow: '0 5px 20px rgba(0,0,0,0.1)',
                position: 'relative'
              }}>
          <div style={{
                  fontSize: '3rem',
                  color: '#667eea',
                  opacity: 0.2,
                  position: 'absolute',
                  top: '10px',
                  left: '20px'
                }}>
            "
          </div>
          <p style={{
                  color: '#555',
                  lineHeight: '1.8',
                  marginBottom: '1.5rem',
                  fontStyle: 'italic',
                  position: 'relative',
                  zIndex: 1
                }}>
            {testimonial.text}
          </p>
          <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '1rem'
                }}>
            <img src={testimonial.image} alt={testimonial.name} style={{
                    width: '60px',
                    height: '60px',
                    borderRadius: '50%',
                    objectFit: 'cover',
                    border: '3px solid #667eea'
                  }} />
            <div>
              <div style={{
                      fontWeight: '600',
                      color: '#1e3c72',
                      marginBottom: '0.2rem'
                    }}>
                {testimonial.name}
              </div>
              <div style={{
                      color: '#888',
                      fontSize: '0.9rem'
                    }}>
                {testimonial.role}
              </div>
            </div>
          </div>
        </div>
        ))}
      </div>
    </div>
  </div>

  {/* CTA Section */}
  <div style={{
        padding: '4rem 2rem',
        background: 'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h2 style={{
            fontSize: 'clamp(2rem, 4vw, 2.8rem)',
            fontWeight: '700',
            marginBottom: '1rem'
          }}>
        Ready to Invest in Your Future?
      </h2>
      <p style={{
            fontSize: 'clamp(1.1rem, 2vw, 1.3rem)',
            opacity: 0.9,
            marginBottom: '2rem'
          }}>
        Get in touch with our expert team today and discover the perfect property for your needs
      </p>
      <div style={{
            display: 'flex',
            gap: '1rem',
            justifyContent: 'center',
            flexWrap: 'wrap'
          }}>
        <button style={{
              padding: '1rem 2.5rem',
              fontSize: '1.1rem',
              fontWeight: '600',
              background: '#FFBE1D',
              border: 'none',
              borderRadius: '50px',
              color: '#000',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 5px 20px rgba(255,190,29,0.4)'
            }} onMouseOver={(e)=> {
          e.target.style.transform = 'translateY(-3px)';
          e.target.style.boxShadow = '0 8px 25px rgba(255,190,29,0.6)';
          }}
          onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 5px 20px rgba(255,190,29,0.4)';
          }}>
          📞 Contact Now
        </button>
        <button style={{
              padding: '1rem 2.5rem',
              fontSize: '1.1rem',
              fontWeight: '600',
              background: '#2180CE',
              border: 'none',
              borderRadius: '50px',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              boxShadow: '0 5px 20px rgba(33,128,206,0.4)'
            }} onMouseOver={(e)=> {
          e.target.style.transform = 'translateY(-3px)';
          e.target.style.boxShadow = '0 8px 25px rgba(33,128,206,0.6)';
          }}
          onMouseOut={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 5px 20px rgba(33,128,206,0.4)';
          }}>
          🏡 Book a Plot
        </button>
      </div>
    </div>
  </div>
</div>
);
};

export default Home;